module.exports = __webpack_public_path__ + "static/media/NEW-DHEYA.d1d53b27.png";